import cn from "@/helpers/classNames";
import React from "react";
import { Badge } from "./Badge";

function getFeatureStateBadgeClassName(featureState: string) {
  switch (featureState.trim().toLowerCase()) {
    case "beta":
      return "border-violet-200 bg-violet-50 font-semibold text-violet-700 dark:border-violet-400/30 dark:bg-violet-400/10 dark:text-violet-300";
    default:
      return "";
  }
}

export function FeatureStateBadge({
  featureState,
  ...props
}: React.ComponentProps<typeof Badge> & {
  featureState: string;
}) {
  const normalizedFeatureState = featureState.trim();

  if (!normalizedFeatureState) {
    return null;
  }

  return (
    <Badge
      {...props}
      variant="outline"
      className={cn(
        "rounded-full px-2 py-0.5 text-xs",
        getFeatureStateBadgeClassName(normalizedFeatureState),
        props.className,
      )}
    >
      {normalizedFeatureState}
    </Badge>
  );
}
